import { render } from "./MLoadingOverlay.vue?vue&type=template&id=72b78468"
import script from "./MLoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./MLoadingOverlay.vue?vue&type=script&lang=ts"
script.render = render

export default script